import { LOGIN_LOOKBACK_DAYS } from '@/lib/activity/config'
import { type SectionConfig } from '@/utils/get-matched-section'

// Client Success is a cross-org onboarding + org-management app gated by
// `client-success:read`. Like admin it has no `orgSlug` prefix, so every key
// here is the literal `/client-success/...` path. Breadcrumbs are built
// deterministically from the pathname (see build-client-success-breadcrumbs.ts),
// so entries keep `showBreadcrumbs: false` and terse section titles — the
// drilled-into org name is surfaced by the sidebar's Organization scope block.
export const sectionConfig: SectionConfig = {
  '/client-success': {
    title: 'Home',
    description: 'Onboard and manage customer organizations.',
    showBreadcrumbs: false
  },

  '/client-success/customer-users': {
    title: 'Customer Users',
    description: `Every customer user and the orgs and groups they belong to. Open a row to make changes in that org. Last sign-in covers the past ${LOGIN_LOOKBACK_DAYS} days.`,
    showBreadcrumbs: false
  },

  '/client-success/portal-managers': {
    title: 'Portal Managers',
    description:
      'Customer organizations whose Portal Manager seats need a look, and every customer Portal Manager.',
    showBreadcrumbs: false
  },

  // ── Organizations ─────────────────────────────────────────────────────────
  // The org list lives on Home (drill-in grid); no standalone list page.
  '/client-success/organizations/new': {
    fullBleed: true,
    title: 'Onboard Organization',
    showBreadcrumbs: false
  },

  // ── Organization drill-in ───────────────────────────────────────────────
  '/client-success/organizations/[organizationId]/overview': {
    title: 'Overview',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/members': {
    title: 'Members',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/members/[memberId]': {
    title: 'Member',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/groups': {
    title: 'Groups',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/groups/[groupId]': {
    title: 'Group',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/groups/[groupId]/members': {
    title: 'Group Members',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/groups/[groupId]/properties':
    {
      title: 'Group Properties',
      showBreadcrumbs: false
    },
  '/client-success/organizations/[organizationId]/properties': {
    title: 'Properties',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/invitations': {
    title: 'Invitations',
    showBreadcrumbs: false
  },
  '/client-success/organizations/[organizationId]/settings': {
    title: 'Organization Settings',
    showBreadcrumbs: false
  }
}
